import React from 'react';

import RemoveIcon from '@atlaskit/icon/glyph/editor/close';

import { Button } from '@qality/common-components/src/atoms/Button';
import { Text } from '@qality/common-components/src/atoms/Text';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { NoPermissionToViewIssuesBanner } from '@qality/common-components/src/molecules/NoPermissionToViewIssuesBanner';
import { SpinnerLoader } from '@qality/common-components/src/molecules/SpinnerLoader';
import { IssueStatusSimple } from '@qality/common-model';

import {
  BugsListBannerStyled,
  IssuesListRowActionIconStyled,
  IssuesListRowStyled,
  IssuesListStyled,
  NoIssuesFoundStyled,
  ReportedBugsListStyled,
} from './ReportedBugsList.styled';

type BugIssue = {
  iconSrc: string;
  issueId: string;
  issueKey: string;
  issueLink: string;
  linkedIssueId: number;
  status: IssueStatusSimple;
  testExecutionStepId: string;
  title: string;
};

type Props = {
  errorsCount: number;
  isLoading: boolean;
  issuesList: Array<BugIssue>;
  onRemove: () => void;
  readOnly: boolean;
  shouldAddStrikethrough: boolean;
};

export const ReportedBugsListView = ({
  errorsCount,
  isLoading,
  issuesList = [],
  onRemove,
  readOnly,
  shouldAddStrikethrough,
}: Props): JSX.Element => {
  return (
    <ReportedBugsListStyled>
      {isLoading && (
        <SpinnerLoader
          text='We are loading issues...'
          shouldHideContent={true}
        />
      )}
      <IssuesListStyled>
        {!issuesList.length && !errorsCount ? (
          <NoIssuesFoundStyled>
            <Text inactive>No issues found</Text>
          </NoIssuesFoundStyled>
        ) : (
          issuesList.map(
            (issue) =>
              issue && (
                <IssuesListRowStyled key={issue.issueKey}>
                  <Issue
                    issueKey={issue.issueKey}
                    issueLink={issue.issueLink}
                    iconSrc={issue.iconSrc}
                    title={issue.title}
                    status={issue.status}
                    shouldAddStrikethrough={shouldAddStrikethrough}
                  />

                  {!readOnly && (
                    <IssuesListRowActionIconStyled>
                      <Button
                        appearance='subtle-link'
                        onClick={onRemove?.bind(this, issue.issueId)}
                        isDisabled={!issue.issueKey}
                      >
                        <RemoveIcon size='small' label='RemoveIcon' />
                      </Button>
                    </IssuesListRowActionIconStyled>
                  )}
                </IssuesListRowStyled>
              )
          )
        )}
      </IssuesListStyled>
      {!!errorsCount && (
        <BugsListBannerStyled>
          <NoPermissionToViewIssuesBanner numberOfIssues={errorsCount} />
        </BugsListBannerStyled>
      )}
    </ReportedBugsListStyled>
  );
};
